import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Navbar } from "@/components/Navbar";
import { OffersBanner } from "@/components/OffersBanner";
import { FestiveOffers } from "@/components/FestiveOffers";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { WhyChoose } from "@/components/WhyChoose";
import { Categories } from "@/components/Categories";
import { StoreGallery } from "@/components/StoreGallery";
import { Boutique } from "@/components/Boutique";
import { Brands } from "@/components/Brands";
import { Essentials } from "@/components/Essentials";
import { DeliveryPromo } from "@/components/DeliveryPromo";
import { HowToOrder } from "@/components/HowToOrder";
import { VisitStore } from "@/components/VisitStore";
import { Trust } from "@/components/Trust";
import { Reviews } from "@/components/Reviews";
import { Faq } from "@/components/Faq";
import { FinalCta, Footer } from "@/components/Footer";
import { StickyBar } from "@/components/StickyBar";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-charcoal min-h-screen pb-[72px] md:pb-0">
      <div className="grain-overlay" aria-hidden="true" />
      <OffersBanner />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <WhyChoose />
        <Categories />
        <FestiveOffers />
        <StoreGallery />
        <Boutique />
        <Brands />
        <Essentials />
        <DeliveryPromo />
        <HowToOrder />
        <VisitStore />
        <Trust />
        <Reviews />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
      <StickyBar />
    </div>
  );
}

export default App;
